import { signal } from '@preact/signals-react';

const usuario = signal({
    autenticado: false
});

export default usuario;